import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
    fetchOtherUserProfileRequest,
    searchUserRequest,
} from "../../store/user/user.actions";
import {
    getOtherUserProfile,
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";
import { IsNullOrEmpty } from "../../helpers/utility";
import PrivateProfile from "../OtherProfile/ViewProfile";
import OwnProfile from "./ViewProfile";

function Profile(props) {
    const location = useLocation();
    const dispatch = useDispatch();
    const [userName, setUserName] = useState("");
    const [shopView, setShopView] = useState(false);
    const [category, setCategory] = useState("");
    const history = useNavigate();
    const { userProfile, users, otherUserProfile } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
            users: getSearchedUsers(state),
            otherUserProfile: getOtherUserProfile(state),
        };
    });

    useEffect(() => {
        if (users.length === 0) {
            dispatch(searchUserRequest());
        }
    }, []);

    useEffect(() => {
        let isSet = true;
        if (location && location.pathname) {
            let uName = location.pathname.replace("/", "");
            if (uName.indexOf("shop") > -1) {
                uName = uName.split("/")[0];
                setShopView(true);
                isSet = false;
            }
            setUserName(uName);
            if (
                !IsNullOrEmpty(uName) &&
                uName !== userProfile.account.userName &&
                IsNullOrEmpty(otherUserProfile.id)
            ) {
                let selectedUsers = users.filter(
                    (x) => x.account.userName === uName
                );
                if (selectedUsers.length > 0) {
                    dispatch(
                        fetchOtherUserProfileRequest(
                            selectedUsers[0]._id,
                            history
                        )
                    );
                }
            }
        }

        if (isSet) {
            if (location && location.state && location.state.shop) {
                setShopView(true);
            } else {
                setShopView(false);
            }
        }

        if (location && location.state && location.state.category) {
            setCategory(location.state.category);
        } else {
            setCategory("");
        }
    }, [location]);

    if (
        !IsNullOrEmpty(userName) &&
        userName !== userProfile.account.userName &&
        !IsNullOrEmpty(otherUserProfile.id)
    ) {
        return <PrivateProfile shopView={shopView} category={category} />;
    }
    if (
        !IsNullOrEmpty(userName) &&
        userName !== userProfile.account.userName &&
        IsNullOrEmpty(otherUserProfile.id)
    ) {
        return <span />;
    } else {
        return <OwnProfile category={category} />;
    }
}

export default Profile;
